module.exports = __webpack_public_path__ + "img/heart-red.93468df2.svg";